class ViewportContainer {
    constructor(domContainer) {
        this._domContainer = domContainer;

        this._viewer = document.createElement("div");
        this._border = document.createElement("div");
        this._viewport = document.createElement("div");
        this._resizer = document.createElement("div");
        this._borderParts = Object.fromEntries(["left", "right", "top", "bottom"].map(name => [name, document.createElement("div")]));

        this._viewerPos = { x: 0, y: 0 };
        this._canvasSize = { width: 320, height: 180 };

        Object.assign(this._viewer.style, {
            pointerEvents: "none",
            position: "absolute",
            zIndex: 1000,
        });

        Object.assign(this._border.style, {
            position: "absolute",
            left: 0,
            top: 0,
            cursor: "all-scroll",
        });

        Object.assign(this._borderParts.top.style, {
            left: 0,
            top: 0,
            height: "16px",
        });

        Object.assign(this._borderParts.bottom.style, {
            left: 0,
            height: "16px",
        });

        Object.assign(this._borderParts.left.style, {
            left: 0,
            top: "16px",
            width: "16px",
        });

        Object.assign(this._borderParts.right.style, {
            top: "16px",
            width: "16px",
        });

        for (const name in this._borderParts) {
            const borderPart = this._borderParts[name];
            this._border.appendChild(borderPart);

            Object.assign(borderPart.style, {
                pointerEvents: "auto",
                position: "absolute",
                background: "#00000020",
            });
        }

        Object.assign(this._viewport.style, {
            pointerEvents: "auto",
            position: "absolute",
            left: "16px",
            top: "16px",
            background: "#00000040",
        });

        Object.assign(this._resizer.style, {
            pointerEvents: "auto",
            position: "absolute",
            width: "16px",
            height: "16px",
            cursor: "nwse-resize",
            background: "#00000040",
        });

        this._dragMode = null;
        this._dragStartViewerPos = null;
        this._dragStartCanvasSize = null;
        this._dragGrabPos = null;

        this._dragThis = this._drag.bind(this);
        this._dragStartMoveThis = (e) => this._setDragMode("move", { x: e.pageX, y: e.pageY });
        this._dragStartResizeThis = (e) => this._setDragMode("resize", { x: e.pageX, y: e.pageY });
        this._dragStopThis = (e) => this._setDragMode(null, null);

        this._border.addEventListener("mousedown", this._dragStartMoveThis);
        this._resizer.addEventListener("mousedown", this._dragStartResizeThis);
        window.addEventListener("mouseup", this._dragStopThis);

        this._updateStyle();

        this._domContainer.appendChild(this._viewer);
        this._viewer.appendChild(this._viewport);
        this._viewer.appendChild(this._border);
        this._viewer.appendChild(this._resizer);
    }

    get viewport() {
        return this._viewport;
    }

    get width() {
        return this._canvasSize.width;
    }

    get height() {
        return this._canvasSize.height;
    }

    _updateStyle() {
        const { x, y } = this._viewerPos;
        const { width, height } = this._canvasSize;

        const {
            _viewer: { style: viewer },
            _border: { style: border },
            _viewport: { style: viewport },
            _resizer: { style: resizer },
            _borderParts: {
                left: { style: borderLeft },
                right: { style: borderRight},
                top: { style: borderTop },
                bottom: { style: borderBottom },
            },
        } = this;

        Object.assign(viewer, {
            left: x+"px",
            top: y+"px",
            width: (width+32)+"px",
            height: (height+32)+"px",
        });

        border.width = (width+32)+"px";
        border.height = (height+32)+"px";

        borderTop.width = (width+32)+"px";
        borderBottom.top = (height+16)+"px";
        borderBottom.width = (width+32)+"px";
        borderLeft.height = height+"px";
        borderRight.left = (width+16)+"px";
        borderRight.height = height+"px";

        viewport.width = width+"px";
        viewport.height = height+"px";

        resizer.left = (width+16)+"px";
        resizer.top = (height+16)+"px";
    }

    _drag(e) {
        const offsetX = e.pageX-this._dragGrabPos.x;
        const offsetY = e.pageY-this._dragGrabPos.y;

        const { width, height } = this._domContainer.getBoundingClientRect();

        switch (this._dragMode) {
            case "move":
                const maxX = Math.max(8, width-16);
                const maxY = Math.max(8, height-16);

                this._viewerPos.x = Math.min(Math.max(0, this._dragStartViewerPos.x+offsetX), maxX)
                this._viewerPos.y = Math.min(Math.max(0, this._dragStartViewerPos.y+offsetY), maxY);

                this._updateStyle();
                break;

            case "resize":
                const maxWidth = Math.max(16, width-32);
                const maxHeight = Math.max(16, height-32);

                this._canvasSize.width = Math.min(Math.max(16, this._dragStartCanvasSize.width+offsetX), maxWidth);
                this._canvasSize.height = Math.min(Math.max(16, this._dragStartCanvasSize.height+offsetY), maxHeight);

                this._updateStyle();
                break;
        }
    }

    _setDragMode(mode, grabPos) {
        if (Boolean(this._dragMode) !== Boolean(mode)) {
            if (mode) {
                window.addEventListener("mousemove", this._dragThis);
            } else {
                window.removeEventListener("mousemove", this._dragThis);
            }
        }

        this._dragMode = mode;

        switch (mode) {
            case "move":
                this._dragStartViewerPos = Object.assign({}, this._viewerPos);
                this._dragGrabPos = grabPos;
                break;

            case "resize":
                this._dragStartCanvasSize = Object.assign({}, this._canvasSize);
                this._dragGrabPos = grabPos;
                break;

            default:
                this._dragStartRectangle = null;
                this._dragGrabPos = null;
                break;
        }
    }
}

export default ViewportContainer;
